import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown, Space, Grid, Modal} from 'antd';
import { 
    MenuFoldOutlined, 
    MenuUnfoldOutlined, 
    UserOutlined, 
    LogoutOutlined,
    DashboardOutlined,
    TeamOutlined,
    LinkOutlined,
    LineChartOutlined,
    MessageOutlined,
    CustomerServiceOutlined,
    InfoCircleOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MentorWelcome from '../pages/shared/MentorWelcome';
import MenteeWelcome from '../pages/shared/MenteeWelcome';

const { Header, Sider, Content } = Layout;

const { useBreakpoint } = Grid;

const MainLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const screens = useBreakpoint();
    const [isModalVisible, setIsModalVisible] = useState(false);


    useEffect(() => {
        const hasSeenWelcome = localStorage.getItem(`hasSeenWelcome_${user.id}`);
        if (user.first_login || !hasSeenWelcome) {
            setIsModalVisible(true);
        }
    }, [user]);

    const handleClose = () => {
        setIsModalVisible(false);
        localStorage.setItem(`hasSeenWelcome_${user.id}`, 'true');
    };

    // Map roles to specific menu items
    const menuItems = [
        { 
            key: user?.role === 'mentor' ? '/mentor/dashboard' : (user?.role === 'mentee' ? '/mentee/dashboard' : '/admin/dashboard'), 
            icon: <DashboardOutlined />, 
            label: 'Dashboard' 
        },
        // Admin Sections
        ...(user?.role === 'admin' ? [
            { key: '/admin/users', icon: <TeamOutlined />, label: 'User Management' },
            { key: '/admin/pairing', icon: <LinkOutlined />, label: 'Mentor Pairing' },
            { key: '/admin/reports', icon: <LineChartOutlined />, label: 'Activity Reports' },
        ] : []),
        // Mentor Sections
        ...(user?.role === 'mentor' ? [
            { key: '/mentor/mentees', icon: <TeamOutlined />, label: 'My Mentees' },
            { key: '/mentor/forum', icon: <MessageOutlined />, label: 'Mentors Forum' },
            { key: '/mentor/welcome', icon: <InfoCircleOutlined />, label: 'My Guide' },
        ] : []),
        // Mentee Sections
        ...(user?.role === 'mentee' ? [
            { key: '/mentee/commitments', icon: <LinkOutlined />, label: 'My Commitments' },
            { key: '/mentee/forum', icon: <MessageOutlined />, label: 'Mentees Forum' },
            { key: '/mentee/welcome', icon: <InfoCircleOutlined />, label: 'My Guide' },
        ] : []),
        { key: '/help-desk', icon: <CustomerServiceOutlined />, label: 'Help Desk' },
        // { key: '/about-elevate-her', icon: <InfoCircleOutlined />, label: 'About Elevate Her' },
    ];

    const userMenu = {
        items: [
            { key: 'profile', label: 'Profile', icon: <UserOutlined /> },
            { key: 'logout', label: 'Logout', icon: <LogoutOutlined />, onClick: logout, danger: true },
        ],
    };

    const getDashboardLink = () => {
        if (user?.role === 'admin') return '/admin/dashboard';
        if (user?.role === 'mentor') return '/mentor/dashboard';
        return '/mentee/dashboard';
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider trigger={null} collapsible collapsed={collapsed} theme="dark" style={{ backgroundColor: '#1A1A1B' }}
            collapsedWidth={screens.xs ? 0 : 80}
            breakpoint="lg"
            onBreakpoint={(broken) => {
          if (broken) setCollapsed(true);
        }}>
                {/* LOGO SECTION */}
                <div 
                    style={{ 
                        padding: collapsed ? '16px 8px' : '16px', 
                        textAlign: 'center', 
                        cursor: 'pointer',
                        transition: 'all 0.3s'
                    }}
                    onClick={() => navigate(getDashboardLink())}
                >
                    <img 
                        src="/assets/images/logo.png" 
                        alt="Chalom Logo" 
                        style={{ 
                            width: collapsed ? '32px' : '40px', 
                            height: 'auto',
                            marginBottom: collapsed ? 0 : '8px'
                        }} 
                    />
                   
                </div>
                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    items={menuItems}
                    onClick={({ key }) => navigate(key)}
                    style={{ backgroundColor: '#1A1A1B' }}
                />
            </Sider>
            <Layout>
                <Header style={{ padding: '0 24px', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button
                        type="text"
                        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        onClick={() => setCollapsed(!collapsed)}
                        style={{ fontSize: '16px', width: 64, height: 64 }}
                    />
                    <Space size="large">
                        <span style={{ fontWeight: 'bold' }}>{user?.name} <span style={{ color: '#FE1F08', fontSize: '12px' }}>({user?.role?.toUpperCase()})</span></span>
                        <Dropdown menu={userMenu}>
                            <Avatar style={{ backgroundColor: '#FE1F08', cursor: 'pointer' }} icon={<UserOutlined />} />
                        </Dropdown>
                    </Space>
                </Header>
                <Content style={{ margin: '24px 16px', padding: 24, minHeight: 280, background: '#fff', borderRadius: 8 }}>
                    <Outlet />
                </Content>
            </Layout>
            <Modal
            open={isModalVisible}
            footer={null}
            closable={false} // Force them to read/interact
            width={800}
            centered
            bodyStyle={{ padding: 0 }} // Remove default padding to let component shine
        >
            {user.role === 'mentor' ? (
                <MentorWelcome onGetStarted={handleClose} />
            ) : (
                <MenteeWelcome onGetStarted={handleClose} />
            )}
        </Modal>
        </Layout>
    );
};

export default MainLayout;